module.exports = __webpack_public_path__ + "static/media/LIT-BNB.4ba279cd.svg";